<template>
    <div class="er_main">
        <div class="mainbg">

            <div class="mr">

                <div class="abnr">
                    <div class="new_con">
                        <h1 class="title01"><strong>{{contentObj.title}}</strong></h1>
                        <div class="datebt">文章来源：{{contentObj.author}}   发布时间:{{formartTime2date(contentObj.publishTime)}}</div>
                        <div id="content_page" v-html="contentObj.content" class="contentDiv">
                        </div>
                    </div>

                </div>
            </div>
            <div class="clear"></div>

        </div>

    </div>
</template>

<script>
    import commonFun from "@/util/common.js";
    export default {
        name: "NewsItem",
        props: {
            datalist: {
                type: Object,
            },
        },
        data() {
            return {
                contentObj:{},

                isActiveIndex: null, // 用于跟踪当前激活的菜单项索引
            }
        },
        mounted() {

        },
        methods: {
            formartTime2date(time){
                return  commonFun.formartDate(time)
            },
            handleMouseOver(index) {
                this.isActiveIndex = index;
            },
            handleMouseOut(index) {
                if (this.isActiveIndex === index) {
                    this.isActiveIndex = null;
                }
            },
            gotoMenu(item){
                let router = commonFun.getRouter('Outsourcing',item.fieldCode,item.id);
                router = '/' + router;
                this.$router.push(router);
            },
            goto(url){
                url = url.replace('/','');
                this.$router.push(url);
            },
        },
        watch: {
            datalist: {
                handler(newVal) {
                    let data = newVal.menuList;
                    this.contentObj = newVal;

                    //得到激活项
                    if(data && data.length >0){
                        let checkCode = newVal.fieldCode.replace("/",'');
                        for(let i=0;i< data.length;i++){
                            let menuObj = data[i];
                            let mcode = menuObj.fieldCode.replace("/",'');
                            if(checkCode == mcode){
                                this.isActiveIndex = i;
                                break;
                            }
                        }
                    }
                },
                immediate: true
            },
        }
    }
</script>

<style lang="scss" scoped >
    *{ margin:0; padding:0;}
    .body{ color:#666; font:12px "AlibabaPuHuiTi_3_55_Regular";background:#daecec;}
    a{ color:#666; text-decoration:none; blr:expression(this.onFocus=this.blur()); outline:none; cursor: pointer; }
    a:hover{ color:#ea5503; text-decoration:underline;}

    .er_main{width:100%;margin:0 auto;}
    .mainbg{height:auto!important;min-height:500px;height:500px;}
    .ml{height:auto !important;min-height:200px;height:200px;padding:5px 3px 0px 0px;width:213px;float:left;background:url("../../../assets/images/bg_touyin.jpg") no-repeat left top;}
    .mlnav{height:auto!Important;height:50px;min-height:50px;padding:9px 5px 33px 13px;width:200px;}
    .mlnav li{cursor: pointer; line-height:35px;padding-left:10px;background:url("../../../assets/images/bg_left1.jpg") no-repeat left bottom;height:auto!Important;height:35px;min-height:35px;}
    .mlnav li a{padding:0 0 0 15px;	background:url("../../../assets/images/list1.jpg") no-repeat left 2px;color:#666;line-height:35px;}
    .mlnav li a:hover,.mlnav li a.hover{color:#006765;text-decoration:none;background:url("../../../assets/images/list2.jpg") no-repeat left 2px;}
    .malepu{width:213px;height:auto !important;min-height:67px;height:67px;text-align:center;padding-bottom:20px; display:none;}
    .malepu img{border:0;}
    .mr{width:100%;height:auto!important;height:400px;min-height:400px;float:left;/*padding:0 20px 0 20px;*/position:relative;}
    .bt2{height:35px;border-bottom:1px solid #dbdbdb;padding-left:13px;position:relative;}
    .bt2 strong{font-size:14px;color:#036d6a;background:url("../../../assets/images/dot_2.jpg") no-repeat left 14px;width:500px;display:block;padding-left:14px;/*line-height:35px;*/padding-top:12px;}
    .bt2 p{position:absolute;right:200px;top:14px;color:#666;}
    .bt2 p a{color:#666;}
    .bt2 p a:hover{color:#036d6a;text-decoration:none;}
    .abnr{line-height:24px;padding:20px;height:auto!Important;height:200px;min-height:200px;}
    .clear {clear: both;height: 0;overflow: hidden;}
    a {
        color: #666;
        text-decoration: none;
        blr: expression(this.onFocus=this.blur());
        outline: none;
    }
    .adv_gd{ height:auto!Important; height:205px; min-height:205px; margin:0 auto;padding:10px 0 20px; margin:0 10px;}
    .adv_gd img{float:left;}

    .adv_lei li a:hover{background-position:left bottom;}
    .new_list{width:1000px;height:auto !important;	min-height:10px;height:100px;padding-bottom:15px;margin:0 auto;}
    .new_list li{width:678px;height:30px;border-bottom:#e5e5e5 1px solid;line-height:30px; position:relative;}
    .new_list li a{text-decoration:none;}
    .new_list li span{ position:absolute; right:0; top:0;}
    .new_con{width:100%;height:auto !important;min-height:200px;height:200px;line-height:25px;margin:0 auto;padding-bottom:10px;}
    .new_tit{font-size:16px;text-align:center;border-bottom:1px solid #dbdbdb;line-height:58px;margin-bottom:25px;}
    .title01{font-size:16px;text-align:center;border-bottom:1px solid #dbdbdb;line-height:58px;}
    .datebt{ height:25px; line-height:25px; margin-bottom:20px; text-align:center; color:#666; font-size:12px; border-bottom:1px solid #dbdbdb;}
    .dot::before {
        content: '';
        display: inline-block;
        width: 5px; /* 圆点的宽度 */
        height: 5px; /* 圆点的高度 */
        background-color: black; /* 圆点的颜色 */
        border-radius: 50%; /* 将矩形变成圆形 */
        margin-right: 5px; /* 与后面内容的间隔 */
    }
    .langu{width:79px;height:21px;color:#006765;line-height:21px;position:absolute;right:0px;top:7px;text-align:center;}
    .page{height:33px;vertical-align:middle;text-align:right;padding-right:5px;}
    #dcms_pager .pages {border:none;text-transform:uppercase;font-size:12px;padding:10px 0 10px 0;padding:0;height:10px;clear:both;color:#333;}
    #dcms_pager .pages a {text-align:center; vertical-align:middle;padding-top:4px; padding-bottom:5px; padding-left:5px; padding-right:5px;border:1px solid #c9c9c9; text-decoration:none;margin:0 5px 0 0;
        color:#333;font-size:12px;height:32px;line-height:35px;}
    #dcms_pager .pages a:hover { cursor:pointer; color:#FF0000;}
    #dcms_pager .pages .pgempty {color:#333;}
    #dcms_pager .pages .pgcurrent {color:#333;}

    /* 新增内容区域图片样式 */
    .contentDiv {
        ::v-deep img {
            max-width: 100% !important;
            height: auto !important;
            display: block;
            margin: 0 auto;
        }

        ::v-deep img:hover {
            transform: scale(0.95);
            transition: transform 0.3s ease;
        }
    }

    /* 原全局img样式修改为： */
    img {
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain;
    }
</style>
